<template>
  <div class="about vld-parent">
    <loading :active.sync="isLoading" :is-full-page="true" />

    <form class="w-auto mx-16 mt-16 text-center" autocomplete="off">
      <div class="mb-6 md:flex md:items-center">
        <div class="md:w-1/3">
          <label class="block pr-4 mb-1 font-bold text-gray-500 md:text-right md:mb-0" for="title">
            Title
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="w-full px-4 py-2 leading-tight text-gray-700 bg-gray-200 border-2 border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-purple-500"
            id="title"
            type="text"
            v-model="name"
          />
        </div>
      </div>
      <div class="mb-6 md:flex md:items-center">
        <div class="md:w-1/3">
          <label class="block pr-4 mb-1 font-bold text-gray-500 md:text-right md:mb-0" for="upc">
            UPC/DPCI/PRODUCT#
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="w-full px-4 py-2 leading-tight text-gray-700 bg-gray-200 border-2 border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-purple-500"
            id="upc"
            type="text"
            v-model="upc"
          />
        </div>
      </div>
      <div class="mb-6 md:flex md:items-center">
        <div class="md:w-1/3">
          <label class="block pr-4 mb-1 font-bold text-gray-500 md:text-right md:mb-0" for="price">
            Price
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="w-full px-4 py-2 leading-tight text-gray-700 bg-gray-200 border-2 border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-purple-500"
            id="price"
            type="number"
            step="0.1"
            v-model="price"
          />
        </div>
      </div>
      <div class="mb-6 md:flex md:items-center">
        <div class="md:w-1/3">
          <label
            class="block pr-4 mb-1 font-bold text-gray-500 md:text-right md:mb-0"
            for="imageURL"
          >
            Image URL
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="w-full px-4 py-2 leading-tight text-gray-700 bg-gray-200 border-2 border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-purple-500"
            id="imageURL"
            type="text"
            v-model="imageURL"
          />
        </div>
      </div>
      <div class="mb-6 md:flex md:items-center">
        <div class="md:w-1/3">
          <label class="block pr-4 mb-1 font-bold text-gray-500 md:text-right md:mb-0" for="priority">
            Priority
          </label>
        </div>
        <div class="md:w-2/3">
          <t-select
            name="priority"
            class="w-full px-4 py-2 leading-tight text-gray-700 bg-gray-200 border-2 border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-purple-500"
            v-model="priority"
            :options="[1, 2, 3, 4, 5]"
          />
        </div>
      </div>
      <div class="mb-6 md:flex md:items-center">
        <div class="md:w-1/3">
          <label
            class="block pr-4 mb-1 font-bold text-gray-500 md:text-right md:mb-0"
            for="storeType"
          >
            Store Type
          </label>
        </div>
        <div class="flex justify-center py-4 mt-3 md:w-2/3">
          <div class="flex items-center mr-4">
            <input
              class="inline-block w-8 h-8 mr-2 border rounded-full border-grey flex-no-shrink"
              type="radio"
              id="walmart"
              value="Walmart"
              v-model="type"
            />
            <label class="text-xl" for="walmart">Walmart</label>
          </div>
          <div class="flex items-center ml-4">
            <input
              class="inline-block w-8 h-8 mr-2 border rounded-full border-grey flex-no-shrink"
              type="radio"
              id="target"
              value="Target"
              v-model="type"
            />
            <label class="text-xl" for="target">Target</label>
          </div>
          <div class="flex items-center ml-4">
            <input
              class="inline-block w-8 h-8 mr-2 border rounded-full border-grey flex-no-shrink"
              type="radio"
              id="lowes"
              value="Lowes"
              v-model="type"
            />
            <label class="text-xl" for="lowes">Lowes</label>
          </div>
        </div>
      </div>
      <button
        class="px-6 py-4 mt-5 text-xl text-white bg-green-400 rounded-lg shadow-lg"
        type="button"
        @click="addNewProduct"
      >
        Add New
      </button>
    </form>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import GET_PRODUCTS from '@/graphql/GetProducts';
import GET_STORELISTS from '../graphql/GetStoreLists';

export default {
  name: 'Add',
  data() {
    return {
      name: '',
      price: 0,
      upc: '',
      type: 'Walmart',
      imageURL: '',
      isLoading: false,
      storeLists: {},
      priority: 1,
    };
  },
  async created() {
    const { data } = await this.$apollo.query({ query: GET_STORELISTS });
    if (data.StoreListMany) {
      data.StoreListMany.forEach((e) => {
        this.storeLists[e.name] = e;
      });
    }
  },
  methods: {
    async addNewProduct() {
      // eslint-disable-next-line
      const { name, price, upc, type, imageURL, priority } = this;
      this.isLoading = true;
      try {
        const zipCodes = this.storeLists[type.toLowerCase()].list;
        const newProduct = {
          name: name.trim(),
          price: +price,
          upc: upc.trim(),
          type: type.toLowerCase(),
          imageURL: imageURL.trim(),
          zipCodes,
          priority: +priority,
        };
        const d = await this.$apollo.mutate({
          mutation: gql`
            mutation($record: CreateOneProductInput!) {
              ProductCreateOne(record: $record) {
                record {
                  _id
                  upc
                  price
                  name
                  createdAt
                  type
                  imageURL
                  priority
                }
              }
            }
          `,
          variables: {
            record: newProduct,
          },
          update: (store, { data: { ProductCreateOne } }) => {
            const data = store.readQuery({ query: GET_PRODUCTS });
            data.ProductMany.unshift(ProductCreateOne.record);
            store.writeQuery({ query: GET_PRODUCTS, data });
          },
        });
        const { _id, ...rest } = d.data.ProductCreateOne.record;
        this.$toasted.success('Added product!', {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
        this.name = '';
        this.upc = '';
        this.price = 0;
        this.$store.commit('setActiveProduct', { _id, ...rest });
        this.$router.push(`products/${_id}`);
      } catch (error) {
        console.log(error);
        this.$toasted.error('Error adding the product!', {
          theme: 'bubble',
          position: 'top-center',
          duration: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
